import {
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Typography,
} from "@suraasa/placebo-ui"
import { AuthManager } from "features/Authentication/AuthManager"
import { context } from "global/Context/context"
import { GrowthSpaceImage } from "growthspace/DefaultLogo"
import { Check, NavArrowRight } from "iconoir-react"
import { useContext, useState } from "react"
import { buildUserName } from "utils/helpers"

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/HoverCard"

const SwitchGrowthspace = ({ openOnHover = true }) => {
  const { growthspaces, switchGrowthspace } = useContext(context)

  const auth = AuthManager.getPlatformAuth()
  const [open, setOpen] = useState(false)

  if (!openOnHover) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="mx-1 my-1.5 cursor-pointer rounded-lg border border-onSurface-200 bg-onSurface-50 py-1 pl-1.5 pr-0.5">
            <div className="flex flex-row items-center justify-between overflow-hidden">
              <Typography
                variant="strongSmallBody"
                className="text-onSurface-600"
              >
                Switch Growthspace
              </Typography>
              <NavArrowRight height={16} width={16} />
            </div>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[280px] !rounded-2xl">
          <DropdownMenuGroup>
            {growthspaces.map((item, i) => {
              const isSelected = item.isCurrent === true

              return (
                <DropdownMenuItem
                  onClick={() => {
                    if (!isSelected) {
                      switchGrowthspace(
                        item.organization?.id.toString() ?? "personal"
                      )
                    }
                  }}
                  key={item.organization?.id ?? item.userUuid}
                  className={cn(
                    "!rounded-2xl w-full block transition-colors",
                    {
                      "mb-0.5": i !== growthspaces.length - 1,
                    },
                    isSelected
                      ? "bg-surface-100 hover:bg-surface-100"
                      : "hover:bg-surface-50"
                  )}
                >
                  <div className="flex w-full flex-row items-center justify-between">
                    <div className="flex flex-row items-center">
                      <GrowthSpaceImage
                        className="size-[30px]"
                        growthspace={item}
                      />
                      <div className="ml-1 flex flex-col">
                        <Typography
                          variant="smallBody"
                          className="text-onSurface-800"
                        >
                          {item.organization
                            ? item.organization.name
                            : auth?.user
                            ? buildUserName(auth.user)
                            : ""}
                        </Typography>
                        <Typography
                          variant="smallBody"
                          className="text-onSurface-500"
                        >
                          {item.organization
                            ? "School Growthspace"
                            : "Personal Growthspace"}
                        </Typography>
                      </div>
                    </div>
                    {isSelected && <Check height={20} width={20} />}
                  </div>
                </DropdownMenuItem>
              )
            })}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }

  return (
    <HoverCard
      onOpenChange={setOpen}
      open={open}
      openDelay={0}
      closeDelay={100}
    >
      <HoverCardTrigger onClick={() => setOpen(true)}>
        <div className="mx-1 my-1.5 cursor-pointer rounded-lg border border-onSurface-200 bg-onSurface-50 py-1 pl-1.5 pr-0.5">
          <div className="flex flex-row items-center justify-between overflow-hidden">
            <Typography
              variant="strongSmallBody"
              className="text-onSurface-600"
            >
              Switch Growthspace
            </Typography>
            <NavArrowRight height={16} width={16} />
          </div>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-[280px] !rounded-2xl bg-surface !p-1">
        {growthspaces.map((item, i) => {
          const isSelected = item.isCurrent === true

          return (
            <button
              onClick={() => {
                if (!isSelected) {
                  switchGrowthspace(
                    item.organization?.id.toString() ?? "personal"
                  )
                }
              }}
              key={item.organization?.id ?? item.userUuid}
              className={cn(
                "!rounded-2xl w-full block transition-colors p-1 text-start",
                {
                  "mb-0.5": i !== growthspaces.length - 1,
                },
                isSelected
                  ? "bg-surface-100 hover:bg-surface-100"
                  : "hover:bg-surface-50"
              )}
            >
              <div className="flex w-full flex-row items-center justify-between">
                <div className="flex flex-row items-center">
                  <GrowthSpaceImage
                    className="size-[30px]"
                    growthspace={item}
                  />
                  <div className="ml-1 flex flex-col">
                    <Typography
                      variant="smallBody"
                      className="text-onSurface-800"
                    >
                      {item.organization
                        ? item.organization.name
                        : auth?.user
                        ? buildUserName(auth.user)
                        : ""}
                    </Typography>
                    <Typography
                      variant="smallBody"
                      className="text-onSurface-500"
                    >
                      {item.organization
                        ? "School Growthspace"
                        : "Personal Growthspace"}
                    </Typography>
                  </div>
                </div>
                {isSelected && <Check height={20} width={20} />}
              </div>
            </button>
          )
        })}
      </HoverCardContent>
    </HoverCard>
  )
}

export default SwitchGrowthspace
